import rootSaga from './sagas/indexSagas'
import { sagaMiddleware } from './Enhancers'
// run the rootsaga
sagaMiddleware.run(rootSaga)
